function signIn(fromPage) {
  let href = `/LogonForm`;
  if (fromPage) {
    href += `?URL=${fromPage}`;
  }
  window.location.href = href;
}
const wcsEditPassword = async () => {
  if (typeof window !== "undefined") {
    window.location.href = window.location.href = `${window.location.origin}/ChangePassword?fromPage=AccountInformationView&URL=%2fLogonForm`;
  }
};
const wcsEditEmail = async () => {
  if (typeof window !== "undefined") {
    window.location.href = `${window.location.origin}/LogonForm?fromPage=/editAzureUserEmail`;
  }
};
export {
  signIn,
  wcsEditEmail,
  wcsEditPassword
};
